
<template>
    <footer class="page-footer" aria-label="Footer">
        <p>
            The source for this site and some of my other projects are available on my
            <a href="https://gitlab.com/chriscampbell" target="_blank">
                <span>GitLab</span>
                <icon name="gitlab"></icon>
            </a>
        </p>
        <p>
            <a href="mailto:chris@chriscampbell.codes">
                <span>Contact me</span>
                <icon name="envelope"></icon>
            </a>
        </p>
    </footer>
</template>

<script>
import icon from "@/components/Icon.vue";

export default {
    props: ["navItems"],
    components: {
        icon
    }
};
</script>

<style lang="scss">
.page-footer {
    text-align: center;

    a {
        white-space: nowrap;

        .icon {
            margin-left: 0.5rem;
            width: 1.6rem;
            height: 1.6rem;
        }
    }
}
</style>
